import { useSelector } from "react-redux";
import aioaLogo from "../../Assets/img/all-in-one-accessibility-logo.svg";
import aioaLogoLight from "../../Assets/img/all-in-one-accessibility-logo-light.svg";
import readWriteLogo from "../../Assets/img/ReadWriteMadeSimple-horizontal-logo.svg";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import TourGuide from "../TourGuide";
import { useTheme } from "../../Context/ThemeContext";


// component to render logo on dashboard
const DashboardLogo = () => {
  // Redux Data
  const { user, websiteList } = useSelector((store: StoreProptypes) => store);

  const {theme} = useTheme()

  //Functions
  const [searchParams] = useSearchParams();
  const location = useLocation();

  //Get app parameter
  const app = searchParams.get("app");

  const AIOALogo = () => {
    const targetPath = "/front/getting-started";


    return (
        <>
          {!websiteList ? (
              <Link
                  to={location.pathname === targetPath ? targetPath : ""}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (location.pathname === targetPath) {
                      e.preventDefault(); // stop reload / blink
                    }
                  }}
              >
                <img src={theme === 'dark' ? aioaLogoLight : aioaLogo} alt="All in One Accessibility Logo" />
              </Link>
          ) : (
              <img src={theme === 'dark' ? aioaLogoLight : aioaLogo} alt="All in One Accessibility Logo" />
          )}
        </>
    );
  };


  return (
      <>
        <TourGuide />
        <div className="aioa_dashboard-logo tour-logo">
          {user ? <>
            {user.is_extension_user // check if its a read write made simple extension user
                ? <img src={readWriteLogo} alt="ReadWriteMadeSimple Logo" />
                : <AIOALogo />
            }
          </> : <>
            {(app && app === "readwritemadesimple") ? <img src={readWriteLogo} alt="ReadWriteMadeSimple Logo" />
                : <AIOALogo />
            }
          </>}


        </div>
      </>
  )
}


export default DashboardLogo;
